export class Mutuario {
  nome_completo: string;
  cpf: string;
  orgao_id: number;
  matricula: string;
  matricula_dois: string;
  cargo: string;
  estado_civil_id: number;


}
